import {Directive, HostBinding, HostListener, Output, EventEmitter} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';

@Directive({
    selector: '[appDrag]',
    standalone: false
})
export class DragDirective {
  @Output() files: EventEmitter<File[]> = new EventEmitter();

  @HostBinding('style.border') private border = '2px dotted #a4a4a4';

  constructor(private sanitizer: DomSanitizer) {}

  @HostListener('dragover', ['$event']) public onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.border = '2px dotted #ff0059';
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.border = '2px dotted #a4a4a4';
  }

  @HostListener('drop', ['$event']) public onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.border = '2px dotted #a4a4a4';

    let files: File[] = [];
    for (let i = 0; i < evt.dataTransfer.files.length; i++) {
      const file = evt.dataTransfer.files[i];
      files.push(file);
    }
    if (files.length > 0) {
      this.files.emit(files);
    }
  }
}
